module.exports = __webpack_public_path__ + "static/media/remix-vr-classrooms.78f5daa3.png";